export default () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="8" cy="8" r="7.5" fill="#fff" stroke="#E3B340" />
		<path d="M6.857 3.429v5.714l3.429 2.286" stroke="#E3B340" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
